<template>
	<div class="show-fullscreen">
		<router-view></router-view>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
	name: 'Freeze',
	setup() {
		return {}
	},
});
</script>

<script setup lang="ts">
import {provide} from "vue";
import {EasClientKey, FreezeClientKey} from "@/apps/freeze/DI";
import {FreezeClient} from "@/apis/freeze/FreezeClient";
import {EasClient} from "@/apis/freeze/EasClient";

provide(FreezeClientKey, FreezeClient.getInstance())
provide(EasClientKey, EasClient.getInstance());
</script>

<style lang="scss" scoped>

.show-fullscreen {
	height: 100vh;
}

</style>
<style></style>
